<script>
  export let id = 0

  import { _, locale, locales } from 'svelte-i18n'

  import { currentUser, refreshCurrentUser } from '../oauth.js'
  import oAuthConfig from '../oauth_config.js'
  import fetchO from '../oauth.js'

  import WorkoutPlanCardWidget from '../components/WorkoutPlanCardWidget.svelte'

  let user
  let workoutplans
  let error

  async function fetchUser() {
    let response = await fetchO('/users/' + id + '/')

    if (response.status != 200) {
      error = 'User ' + id + ' does not exist'
      return
    }
    user = await response.json()
    console.log('User is now', user)

    response = await fetchO('/workout_plans/?visibility=public&user=' + user.id)
    workoutplans = (await response.json())['results']
    console.log('WorkoutPlans is now', workoutplans)
  }

  $: {
    if (!id || id == 0) {
      id = $currentUser.id
    }
    if (id) {
      fetchUser()
    }
  }

  let profileEditMode = false
  let saving = false
  async function updateProfile(e) {
    console.log('Should save Profile', e.target.elements)
    saving = true

    const displayName = e.target.elements.display_name.value
    const tagline = e.target.elements.tagline.value
    const language = e.target.elements.language.value

    const response = await fetchO('/users/current_user/', {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        display_name: displayName,
        tagline: tagline,
        language: language,
      }),
    })
    console.log('Response is', response)

    refreshCurrentUser()

    // Refetch the data to update this page
    fetchUser()

    saving = false
    profileEditMode = false
  }

  let fileinput
  let uploading = false
  async function onFileSelected(e) {
    console.log('Should change avatar', e)
    uploading = true
    const image = e.target.files[0]

    var data = new FormData()
    data.append('file', image)

    const response = await fetchO('/users/current_user_avatar/', {
      method: 'PUT',
      body: data,
    })
    console.log('Response is', response)

    refreshCurrentUser()

    // Refetch the data to update this page
    fetchUser()

    uploading = false
  }

  async function clearAvatar() {
    console.log('Should clear avatar')

    const response = await fetchO('/users/current_user_avatar/', {
      method: 'DELETE',
    })
    console.log('Response is', response)

    refreshCurrentUser()

    // Refetch the data to update this page
    fetchUser()
  }
</script>

{#if !user && !error}
  <div class="spinner-border" role="status">
    <span class="visually-hidden">{$_('generic.loading')}...</span>
  </div>
{:else if error}
  <div class="alert alert-danger" role="alert">
    {error}
  </div>
{:else}
  <div class="row g-5">
    <div class="col-md-4 pb-4">
      <div class="position-relative">
        {#if user.id == $currentUser.id}
          <div class="position-absolute top-50 end-0">
            <div class="dropdown">
              <button
                class="btn btn-secondary dropdown-toggle"
                type="button"
                id="avatardropdown"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                {#if !uploading}
                  <i class="bi bi-pencil" />
                {:else}
                  <div class="spinner-border spinner-border-sm" role="status" />
                {/if}
              </button>
              <ul class="dropdown-menu" aria-labelledby="avatardropdown">
                <li>
                  <button
                    class="dropdown-item"
                    on:click={() => {
                      fileinput.click()
                    }}
                    ><i class="bi bi-upload" />
                    {$_('profile.upload_avatar')}</button
                  >
                  <input
                    style="display:none"
                    type="file"
                    accept=".jpg, .jpeg, .png"
                    on:change={(e) => onFileSelected(e)}
                    bind:this={fileinput}
                  />
                </li>
                <li>
                  <button class="dropdown-item" on:click={clearAvatar}
                    ><i class="bi bi-x-circle" />
                    {$_('profile.clear_avatar')}</button
                  >
                </li>
              </ul>
            </div>
          </div>
        {/if}
        {#if user.avatar}
          <img
            src={user.avatar.large}
            class="img-thumbnail rounded-circle"
            style="width: 100%;"
            alt="Avatar of {user.display_name}"
          />
        {:else}
          <img
            src="https://avatars.dicebear.com/api/adventurer/{user.id}.svg?background=%23cccccc"
            class="img-thumbnail rounded-circle"
            style="width: 100%;"
            alt="Placeholder Avatar of {user.display_name}"
          />
        {/if}
      </div>

      {#if !profileEditMode}
        <h1>{user.display_name}</h1>
        <p>{user.tagline}</p>
        {#if user.id == $currentUser.id}
          <p>
            <i class="bi bi-envelope-fill" />
            {$_('generic.email')}: {$currentUser.email}
          </p>
          <p>
            <i class="bi bi-flag-fill" />
            {$_('generic.language')}: {$_(
              'generic.lang.' + $currentUser.language
            )}
          </p>

          <div class="d-grid pt-3 gap-1">
            <button
              class="btn btn-outline-primary btn-sm"
              on:click={() => {
                profileEditMode = true
              }}>{$_('profile.edit')}</button
            >
            <a
              role="button"
              href="{oAuthConfig.host}/accounts/email"
              target="_blank"
              class="btn btn-outline-secondary btn-sm"
              >{$_('profile.changeemail')}</a
            >
            <a
              role="button"
              href="{oAuthConfig.host}/accounts/password_change"
              target="_blank"
              class="btn btn-outline-secondary btn-sm"
              >{$_('profile.changepassword')}</a
            >
          </div>
        {/if}
      {:else}
        <form on:submit|preventDefault={updateProfile}>
          <div class="form-floating mb-3">
            <input
              type="text"
              class="form-control"
              id="display_name"
              placeholder="Display Name"
              value={user.display_name}
            />
            <label for="display_name">Display Name</label>
          </div>
          <div class="form-floating mb-3">
            <input
              type="text"
              class="form-control"
              id="tagline"
              placeholder="Tagline"
              value={user.tagline}
            />
            <label for="tagline">Tagline</label>
          </div>
          <div class="form-floating">
            <select class="form-select" id="language" bind:value={$locale}>
              {#each $locales as locale}
                <option value={locale}>{$_('generic.lang.' + locale)}</option>
              {/each}
            </select>
            <label for="language">{$_('generic.language')}</label>
          </div>
          <div class="d-grid pt-3">
            <button type="submit" class="btn btn-primary btn-sm">
              {#if saving}
                <div class="spinner-border spinner-border-sm" role="status" />
              {:else}
                {$_('profile.saveprofile')}
              {/if}
            </button>
          </div>
        </form>
      {/if}

      <p class="pt-2">
        <i class="bi bi-card-list" /> <b>{user.workout_plan_count}</b>
        {$_('profile.plans_number', { values: { n: user.workout_plan_count } })}
        ·
        <b>{user.public_workout_plan_count}</b>
        {$_('profile.public_plans_number', {
          values: { n: user.public_workout_plan_count },
        })}
      </p>
    </div>
    <div class="col-md-8">
      <h2>{$_('profile.public_workout_plans')}</h2>
      <div class="row g-3">
        {#if workoutplans}
          {#each workoutplans as wp}
            <div class="col-sm-12 col-xl-6">
              <WorkoutPlanCardWidget {wp} hideUser="true" />
            </div>
          {/each}
        {/if}
      </div>
    </div>
  </div>
{/if}

<svelte:head>
  {#if user}
    {#if user.id == $currentUser.id}
      <title>{$_('profile.title_own')}</title>
    {:else}
      <title
        >{$_('profile.title', { values: { user: user.display_name } })}</title
      >
    {/if}
  {/if}
</svelte:head>
